import VueRouter from 'vue-router'
import vue from 'vue'

import helpers from 'vue/helpers.js';

import NotFound from 'vue/submittal-manager/not-found';

import MechanicalIndex from 'vue/submittal-manager/mechanical/index';
import MechanicalInformation from 'vue/submittal-manager/mechanical/information/index';
import NewMechanicalInformation from 'vue/submittal-manager/mechanical/information/new';
import MechanicalBrowse from 'vue/submittal-manager/mechanical/browse/index';
import MechanicalReport from 'vue/submittal-manager/mechanical/report/index';
import MechanicalReview from 'vue/submittal-manager/mechanical/review/index';

import AnvilSeismicSetup from 'vue/submittal-manager/seismic-v1/setup';
import AnvilSeismicIdentify from 'vue/submittal-manager/seismic-v1/identify';
import AnvilSeismicSystem from 'vue/submittal-manager/seismic-v1/system';
import AnvilSeismicSummary from 'vue/submittal-manager/seismic-v1/summary';
import AnvilSeismicAttachment from 'vue/submittal-manager/seismic-v1/attachment';
import AnvilSeismicFileUpload from 'vue/submittal-manager/seismic-v1/file-upload';

import SeismicSubmittalSetup from 'vue/submittal-manager/seismic-v2/setup';
import SeismicSubmittalIdentify from 'vue/submittal-manager/seismic-v2/identify';
import SeismicSubmittalSystem from 'vue/submittal-manager/seismic-v2/system';
import SeismicSubmittalSummary from 'vue/submittal-manager/seismic-v2/summary';
import SeismicSubmittalAttachment from 'vue/submittal-manager/seismic-v2/attachment';
import SeismicSubmittalFileUpload from 'vue/submittal-manager/seismic-v2/file-upload';

vue.use(VueRouter);

const routes = [
    {
        path: '/submittal-manager/mechanical',
        component: MechanicalIndex,
        name: 'mechanical',
        children: [
            {
                path: ':projectID/information/new',
                component: NewMechanicalInformation,
                name: 'new-mechanical-information',
                props: true
            },
            {
                path: ':submittalID/information',
                component: MechanicalInformation,
                name: 'mechanical-information',
                props: true
            },
            {
                path: ':submittalID/browse',
                component: MechanicalBrowse,
                name: 'mechanical-browse',
                props: true
            },
            {
                path: ':submittalID/review',
                component: MechanicalReview,
                name: 'mechanical-review',
                props: true
            },
            {
                path: ':submittalID/report',
                component: MechanicalReport,
                name: 'mechanical-report',
                props: true
            }
        ]
    },
    {
        path: '/submittal-manager/seismic/v1/:projectId/new',
        component: AnvilSeismicSetup,
        name: 'seismic-new',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:id/setup',
        component: AnvilSeismicSetup,
        name: 'seismic-setup',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:seismicDesignId/braces/new',
        component: AnvilSeismicIdentify,
        name: 'seismic-brace-new',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:seismicDesignId/braces/:id',
        component: AnvilSeismicIdentify,
        name: 'seismic-brace-identify',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:seismicDesignId/braces/:id/piping',
        component: AnvilSeismicSystem,
        name: 'seismic-brace-piping',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:seismicDesignId/braces/:id/attachment',
        component: AnvilSeismicAttachment,
        name: 'seismic-brace-attachment',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:seismicDesignId/file-upload/new',
        component: AnvilSeismicFileUpload,
        name: 'seismic-file-upload-new',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:seismicDesignId/file-upload/:id',
        component: AnvilSeismicFileUpload,
        name: 'seismic-file-upload',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v1/:id',
        component: AnvilSeismicSummary,
        name: 'seismic-brace-summary',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:projectId/new',
        component: SeismicSubmittalSetup,
        name: 'submittal-new',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:id/setup',
        component: SeismicSubmittalSetup,
        name: 'submittal-setup',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:designId/braces/new',
        component: SeismicSubmittalIdentify,
        name: 'submittal-brace-new',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:designId/braces/:id',
        component: SeismicSubmittalIdentify,
        name: 'submittal-brace-identify',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:designId/braces/:id/piping',
        component: SeismicSubmittalSystem,
        name: 'submittal-brace-piping',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:designId/braces/:id/attachment',
        component: SeismicSubmittalAttachment,
        name: 'submittal-brace-attachment',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:designId/file-upload/new',
        component: SeismicSubmittalFileUpload,
        name: 'submittal-file-upload-new',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:designId/file-upload/:id',
        component: SeismicSubmittalFileUpload,
        name: 'submittal-file-upload',
        props: true
    },
    {
        path: '/submittal-manager/seismic/v2/:id',
        component: SeismicSubmittalSummary,
        name: 'submittal-brace-summary',
        props: true
    },
    {
        path: '/submittal-manager/*',
        component: NotFound
    }
];

const router = new VueRouter({
    mode: 'history',
    //base: '/submittal-manager/',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        if (from.name === 'seismic-new' && to.name === 'seismic-setup') {
            return false;
        } else if (from.name === 'seismic-brace-new' && to.name === 'seismic-brace-identify') {
            return false;
        }

        if (savedPosition) {
            return savedPosition
        } else {
            let $page = $("html, body");
            $page.animate({scrollTop: 0}, 750);
        }
    }
});

export default router;
